import QuestionResponse from "./QuestionResponse";

export default QuestionResponse;
